'use client';
import Image from 'next/image';
import Link from 'next/link';
import { useLocale, useTranslations } from 'next-intl';
import type React from 'react';

import { ContentDto } from '@cineamo/api/models/content/ContentDto.types';

import { loadAsset } from '@cineamo/ui/src/helpers/asset-helper';

import Button from '@cineamo/ui/src/button/NewButton';

import CenterLayout from '@cineamo/composables/src/CenterLayout';
import { useAnalytics } from '@cineamo/composables/src/providers/analyticsProvider';
const ticketUnavailable = loadAsset('/images/illustrations/im-ticketUnavailable.svg');

const ShowingPassedPage: React.FC<{
    contentId: ContentDto['id'];
}> = ({ contentId }) => {
    const t = useTranslations();
    const locale = useLocale();
    const { track } = useAnalytics();

    return (
        <CenterLayout className="flex flex-col space-y-16 p-24 lg:max-w-[480px] lg:mx-auto">
            <h1 className="text-headline-24">{t('tickets.tickets-unavailable')}</h1>
            <Image
                className="self-center"
                src={ticketUnavailable}
                alt={t('tickets.tickets-unavailable')}
                width={240}
                height={180}
            />
            <p className="text-body-14">{t('tickets.tickets-unavailable-message')}</p>
            <Link
                href={`/${locale}/program/${contentId}`}
                onClick={() => {
                    track('Navigated To Movie', {
                        precedingEvent: 'Showing Passed'
                    });
                }}>
                <Button
                    className="w-full min-h-[48px]"
                    labelClassName="text-body-bold-16">
                    {t('common.back')}
                </Button>
            </Link>
        </CenterLayout>
    );
};

export default ShowingPassedPage;
